<template>
  <smd-one-col-layout content-styles="full-width">
    <smd-header class="root-services__header top-bar-box-shadow"
                slot="header"
                v-if="hideTabs">
      <img alt="nowserving logo"
           class="crisp-image"
           src="../../assets/images/nowserving.png"
           slot="left-actions"
           v-if="$isMobile"
           width="123px">
      <smd-fixed-tab-panel slot="left-actions"
                           v-if="!$isMobile"
                           :options="$options.tabs"/>
      <template slot="right-actions">
        <div class="flex-row-center-xy-spaced">
          <smd-btn class="icon-btn"
                   icon="ns-icon-settings"

                   @click="goToSettings">
          </smd-btn>
        </div>
      </template>

    </smd-header>
    <smd-fixed-tab-panel slot="toolbar"
                         v-if="$isMobile"
                         :options="$options.tabs"/>
    <router-view/>
  </smd-one-col-layout>
</template>

<script>
  import Routes from "@/router/routes";
  import HeaderFunctionMixin from '@/mixins/header-functions-mixin'

  export default {
    name: "services",
    mixins: [HeaderFunctionMixin],
    computed: {
      hideTabs() {
        return true
      }
    },
    tabs: [
      // {
      //   name: 'Find a Service',
      //   route: Routes.SERVICES_FIND_A_SERVICE_ROUTE,
      //   to: {
      //     name: Routes.SERVICES_FIND_A_SERVICE_ROUTE
      //   }
      // },
      {
        name: 'Ongoing',
        route: Routes.SERVICES_ONGOING_ROUTE,
        to: {
          name: Routes.SERVICES_ONGOING_ROUTE
        }
      },
      {
        name: 'Past',
        route: Routes.SERVICES_PAST_ROUTE,
        to: {
          name: Routes.SERVICES_PAST_ROUTE
        }
      },
    ],
  }
</script>
<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .root-services__header {
    @include responsive(tablet, "ipad") {
      .smd-fixed-tab-panel {
        border: none;
        margin-bottom: -14px;
      }

      .smd-fixed-tab-panel__item.selected:after {
        bottom: -4px;
      }
    }
    @include responsive(desktop) {

      .smd-fixed-tab-panel {
        border: none;
        margin-bottom: -14px;
      }

      .smd-fixed-tab-panel__item.selected:after {
        bottom: -4px;
      }
    }
  }
</style>
